import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { isPublicEndpoint } from '../config/interceptor.config';
import { allowsSessionlessWorkflowBuilder, redirectToAtsAfterUnauthorized } from '../utils/ats-unauthorized-redirect';
import { ToastService } from '../services/toast.service';
import { UserService } from '../services/user.service';

/**
 * On 401 from protected APIs: toast, then redirect to ATS (after a short delay so the toast is visible).
 * Clears client auth only — does not call ATS `/users/logout`.
 * Skips pre-login routes such as `auth/session/validate`.
 * Also skips forced redirect on local sessionless `/workflow-builder`.
 */
export const unauthorizedInterceptor: HttpInterceptorFn = (req, next) => {
  const user = inject(UserService);
  const toast = inject(ToastService);
  return next(req).pipe(
    catchError((err: unknown) => {
      if (
        err instanceof HttpErrorResponse &&
        err.status === 401 &&
        !isPublicEndpoint(req.url) &&
        !allowsSessionlessWorkflowBuilder()
      ) {
        redirectToAtsAfterUnauthorized(user, toast);
      }
      return throwError(() => err);
    }),
  );
};
